export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      locationUuid: "locations001",
      nickName: "nickname"
    }
  }
}